import { render, staticRenderFns } from "./avator.vue?vue&type=template&id=c5bc1e1e&"
import script from "./avator.vue?vue&type=script&lang=js&"
export * from "./avator.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "avator.vue"
export default component.exports